import { combineReducers } from 'redux';

const masterInitialState = {
  list: null,
  loadStatus: 0,
  didLoadAll: false,
  query: {
    size: 20,
    time: null,
    keyword: '',
  },
};

function masterReducer(state = masterInitialState, action) {
  switch (action.type) {
    case 'LOAD_SALE_ORDER': {
      if (!action.willReload) {
        return {
          ...state,
          loadStatus: 1,
        };
      }

      return {
        ...state,
        loadStatus: 1,
        query: {
          ...state.query,
          ...action.query,
        },
        list: null,
      };
    }

    case 'LOAD_SALE_ORDER_COMPLETION': {
      const { error } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      const list = action.list.map(order => order.orderId);

      return {
        ...state,
        loadStatus: 2,
        didLoadAll: list.length < state.query.size,
        list: state.list ? state.list.concat(list) : list,
      };
    }

    default:
      return state;
  }
}

function ordersReducer(state = {}, action) {
  switch (action.type) {
    // case 'LOAD_GROUP_COMPLETION': {
    //   const { data, error } = action;
    //   const { groupId } = data;

    //   if (error) {
    //     return state;
    //   }

    //   return {
    //     ...state,
    //     [groupId]: data,
    //   };
    // }

    case 'LOAD_SALE_ORDER_COMPLETION': {
      if (action.error) {
        return state;
      }

      const orders = action.list.reduce(
        (obj, group) => {
          const orderId = group.orderId;

          if (orderId) {
            obj[orderId] = { ...obj[orderId], ...group };
          }
          return obj;
        },
        { ...state }
      );

      return orders;
    }

    default:
      return state;
  }
}

export default combineReducers({
  master: masterReducer,
  orders: ordersReducer,
});
